import React, { useState } from "react";
import LineChart from "./LineChart";
import PropTypes from "prop-types";
function Graph({ keys, temp }) {
  const [buttonIndex, setButtonIndex] = useState(0);

  const getButtonIndex = (e) => {
    setButtonIndex(parseInt(e.target.value));
  };
  return (
    <div>
      <div className="Graph">
        <h3 className="Graph__heading">Weather Graph</h3>
        <div className="BtnsDiv">
          {keys.map((obj, index) => (
            <div className="btns" key={index}>
              <button
                value={index}
                onClick={getButtonIndex}
                className={`btns__btn ${
                  index === buttonIndex ? "highlights" : ""
                }`}
                id="button"
              >
                {obj}
              </button>
            </div>
          ))}
        </div>
      </div>
      <LineChart values={temp} index={buttonIndex}></LineChart>
    </div>
  );
}

Graph.defaultProps = {
  keys: [],
  temp: {},
};

Graph.propTypes = {
  keys: PropTypes.array,
  temp: PropTypes.object,
};
export default Graph;
